import { execute, gql, type VariablesOf } from './financial-bff-gql'

export const RISK_FINANCING_SUBMIT_REVALIDATIONS = gql(`
  mutation RiskFinancingSubmitRevalidations($input: SubmitRevalidationsInput!) {
    risk_financing_submit_revalidations(input: $input) {
      success
      message
      data {
        accepted {
          revalidation_id
          revalidation_status
          submission_number
          total_devices
        }
        rejected {
          revalidation_id
          devices {
            brand
            serial_number
          }
          errors {
            code
            detail
          }
        }
        reference_brand_updated {
          revalidation_id
          reference_inverter_brand
          revalidation_status
        }
      }
    }
  }
`)

export type RiskFinancingSubmitRevalidationsVariables = VariablesOf<typeof RISK_FINANCING_SUBMIT_REVALIDATIONS>

export async function mutateRiskFinancingSubmitRevalidations(
  variables: RiskFinancingSubmitRevalidationsVariables,
) {
  const data = await execute(RISK_FINANCING_SUBMIT_REVALIDATIONS, variables)
  return data.risk_financing_submit_revalidations
}
